import './permissions';

import { reducer } from '../reducers/organizations';
import { organizationsRootSaga } from '../sagas/organizations';
import { saga, store } from '../store';

store.addReducers({ organizations: reducer });
saga.run(organizationsRootSaga);
